import { FC } from 'react';
import styles from './DrawingScheduleTable.module.scss';
import { DocumentFileBadge } from '../DocumentFileBadge';

export interface TsaFloorPlanRow {
  id: string;
  drawingFile: string;
  drawingHref?: string;
  source: string;
  titleLevel: string;
  discipline: string;
  compiledBy: string;
  date: string;
}

export interface AdditionalRecordRow {
  id: string;
  filename: string;
  fileType: 'PDF' | 'DWG' | string;
  fileHref?: string;
  description: string;
  discipline: string;
}

export interface DrawingScheduleTableProps {
  variant: 'tsa' | 'additional';
  columns: string[];
  tsaRows?: TsaFloorPlanRow[];
  additionalRows?: AdditionalRecordRow[];
  ariaLabel?: string;
}

export const DrawingScheduleTable: FC<DrawingScheduleTableProps> = ({
  variant,
  columns,
  tsaRows = [],
  additionalRows = [],
  ariaLabel = 'Drawing schedule table',
}) => {
  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableWrapper}>
        <table className={styles.table} aria-label={ariaLabel}>
          <thead>
            <tr>
              {columns.map((col, idx) => (
                <th key={idx} scope="col">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {variant === 'tsa' &&
              tsaRows.map((row) => (
                <tr key={row.id}>
                  <td>
                    <div className={styles.fileCell}>
                      <DocumentFileBadge type="WEBP" />
                      <a href={row.drawingHref || "/more-info"} target="_blank" rel="noopener noreferrer" className={styles.fileLink}>
                        {row.drawingFile}
                      </a>
                    </div>
                  </td>
                  <td className={styles.mutedCell}>{row.source}</td>
                  <td className={styles.primaryCell}>{row.titleLevel}</td>
                  <td>
                    <DocumentFileBadge type={row.discipline} variant="discipline" />
                  </td>
                  <td className={styles.mutedCell}>{row.compiledBy}</td>
                  <td className={styles.mutedCell}>{row.date}</td>
                </tr>
              ))}

            {variant === 'additional' &&
              additionalRows.map((row) => (
                <tr key={row.id}>
                  <td>
                    <div className={styles.fileCell}>
                      <DocumentFileBadge type={row.fileType} />
                      <a href={row.fileHref || "/more-info"} className={styles.fileLink}>
                        {row.filename}
                      </a>
                    </div>
                  </td>
                  <td className={styles.primaryCell}>{row.description}</td>
                  <td>
                    <DocumentFileBadge type={row.discipline} variant="discipline" />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
